import React, { Component } from "react";
import { connect } from "react-redux";
import { createCity } from "../../../actions/masters/cityActions";
import { Link } from "react-router-dom";
import CityForm from "./CityForm";
import history from "../../../history";

class CityCreate extends Component {
  onSubmit = (formValues) => {
    this.props.createCity(
      this.props.match.params.id,
      this.props.match.params.sid,
      formValues
    );
  };

  render() {
    // const { id, sid } = this.props.match.params;
    return (
      <div className="BodyInContainer">
        <div className="d-block clearfix">
          <div className="Header-Content float-start">
            <h3 className="pageMainTitle">Add a City</h3>
          </div>
          <div className="float-end mt-15">
            <Link
              className="float-end cardBackBtn"
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </Link>
          </div>
        </div>
        <CityForm onSubmit={this.onSubmit} />
      </div>
    );
  }
}
export default connect(null, { createCity })(CityCreate);
